import { pinyin } from 'pinyin-pro'

export function getPinyin(chars: string, options?: { tone?: boolean; type?: 'array' | 'string' }): string[] | string {
  const { tone = true, type = 'array' } = options || {}

  if (type === 'string') {
    return pinyin(chars, { toneType: tone ? 'symbol' : 'none', type: 'string' })
  }

  return pinyin(chars, { toneType: tone ? 'symbol' : 'none', type: 'array' })
}

export function getPinyinArray(chars: string, tone: boolean = true): string[] {
  return pinyin(chars, { toneType: tone ? 'symbol' : 'none', type: 'array' })
}
